var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTunnelClosedLane(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "63.868mm",
    height: "37.201mm",
    viewBox: "0 0 63.868 37.201",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(90 104.7 37.546)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.26458 0 0 .26458 67.149 79.503)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: -4.2676,
    width: 140.6,
    height: 241.39,
    ry: 44.816
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.2 0 0 1.2 -54.66 -57.875)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.26458 0 0 .26458 -136.22 -73.023)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m835.71 543.72-23.115-23.243c-1.725-1.7363-4.5217-1.7363-6.2465 0-1.7248 1.7361-1.7248 4.5513 0 6.2878l26.017 26.16c0.91912 0.92525 2.1417 1.3416 3.3451 1.2808 1.2036 0.0609 2.4261-0.3555 3.3453-1.2808l26.017-26.16c1.725-1.7364 1.725-4.5514 0-6.2878-1.725-1.7364-4.5216-1.7363-6.2462 0z",
    fill: "#0f0",
    strokeWidth: 0.10948
  })), /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(90)",
    x: 53.847,
    y: -86.104,
    width: 15.063,
    height: 2.4254,
    ry: 1.2127,
    fill: "#0f0",
    strokeWidth: 0.24445
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.0583 2.1232)",
    fill: "#f00"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.3175 0 0 .3175 -248.68 -158.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m835.71 543.72-23.115-23.243c-1.725-1.7363-4.5217-1.7363-6.2465 0-1.7248 1.7361-1.7248 4.5513 0 6.2878l26.017 26.16c0.91912 0.92525 2.1417 1.3416 3.3451 1.2808 1.2036 0.0609 2.4261-0.3555 3.3453-1.2808l26.017-26.16c1.725-1.7364 1.725-4.5514 0-6.2878-1.725-1.7364-4.5216-1.7363-6.2462 0z",
    fill: "#f00",
    strokeWidth: 0.10948
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.3175 0 0 -.3175 -248.68 191.05)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m835.71 543.72-23.115-23.243c-1.725-1.7363-4.5217-1.7363-6.2465 0-1.7248 1.7361-1.7248 4.5513 0 6.2878l26.017 26.16c0.91912 0.92525 2.1417 1.3416 3.3451 1.2808 1.2036 0.0609 2.4261-0.3555 3.3453-1.2808l26.017-26.16c1.725-1.7364 1.725-4.5514 0-6.2878-1.725-1.7364-4.5216-1.7363-6.2462 0z",
    fill: "#f00",
    strokeWidth: 0.10948
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTunnelClosedLane);
export default __webpack_public_path__ + "static/media/tunnel_closed_lane.f16a32607a7d455835ee26941abf85b0.svg";
export { ForwardRef as ReactComponent };